<!-- <p>zoom-oauth works!</p>
<div>{{ successStr }}</div> -->
<!--<iframe width="100%" height="740" [src]="zoomPath"></iframe>-->
<ng-scrollbar class="global-container" appearance = "compact" #scrollable pointerEventsMethod="scrollbar">
    <div class="m-t-30 d-flex justify-content-center align-items-center">
        <div class="content-msg-wrapper">
            <h1 class="m-0">{{successStr}}</h1>
        </div>
    </div>
</ng-scrollbar>